<template>
	<div content="container-fluid pt-4">
		<div class="subheader">
			<h1 class="subheader-title">
				<i class="subheader-icon fal fa-chart-area"></i>
				Analytics<span class="fw-300">Dashboard</span>
			</h1>
			<div class="subheader-block d-lg-flex align-items-center">
				<div class="d-inline-flex flex-column justify-content-center mr-3">
					<span class="fw-300 fs-xs d-block opacity-50">
						<small>
							{{ __t('ORDERS') }}
						</small>
					</span>
					<span class="fw-500 fs-xl d-block color-primary-500">
						{{animatedOrders}}
					</span>
				</div>
				<span>
						<peity
							:type="'bar'"
							:options="{
								 width: 50,
								 fill : ['#886ab5'],
								 height:32,
								'innerRadius': 10,
								'radius': 40
							}"
							:data="order_data.count_by_day.toString()">
					 </peity>
				</span>
			</div>

			<div
				class="subheader-block d-lg-flex align-items-center border-faded border-right-0 border-top-0 border-bottom-0 ml-3 pl-3">
				<div class="d-inline-flex flex-column justify-content-center mr-3">
					<span class="fw-300 fs-xs d-block opacity-50">
						<small>
							{{ __t('TOTAL_SUM') }}
						</small>
					</span>
					<span class="fw-500 fs-xl d-block color-success-500">
						{{animatedSum | toCurrency}}
					</span>
				</div>
				<span>
					<peity
						:type="'line'"
						:options="{
							 width: 50,
							 fill : ['#1dc9b7'],
							 height:32,
							'innerRadius': 10,
							'radius': 40
						}"
						:data="order_data.order_sum_day.toString()">
				 </peity>
				</span>
			</div>
		</div>

		<orders_heatmap></orders_heatmap>

		<b-overlay rounded="sm" class="pt-4">
			<b-card class="text-left rounded-plus">
				<div class=" wrap pt-0">

					<div class="">
						<span class="badge position-relative mr-2 fs-xl bg-none text-warning">
							<i class="fal fa-edit"></i>
						</span>
						{{__t('SELECT_DATE')}}
					</div>

					<div class="row">
						<div class="col-md-6 col-xs-6 pt-4">
							<div class="row">
								<div class="col-md-6 ">
									<b-form-datepicker @context="onContext" v-model="date" locale="ru-RU"></b-form-datepicker>
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-card>
		</b-overlay>

		<b-overlay rounded="sm" class="pt-4">
			<b-card class="text-left rounded-plus">
				<b-row class="">

					<b-col cols="12" lg="6" sm="12" md="6">
						<bank></bank>
					</b-col>

					<b-col cols="12" lg="6" sm="12" md="6">
						<month_pay></month_pay>
					</b-col>
				</b-row>
			</b-card>
		</b-overlay>

		<b-overlay rounded="sm" class="pt-4">
			<b-card class="text-left rounded-plus">
				<b-row class="">
					<b-col cols="12" lg="6" sm="12" md="6">
						<cur_load></cur_load>
					</b-col>

					<b-col cols="12" lg="6" sm="12" md="6">
						<all_orders></all_orders>
					</b-col>

				</b-row>
			</b-card>
		</b-overlay>

		<b-overlay rounded="sm" class="pt-4">
			<b-card class="text-left rounded-plus">
				<b-row class="">

					<b-col cols="12">
						<stop_list_duration></stop_list_duration>
					</b-col>
				</b-row>
			</b-card>
		</b-overlay>

	</div>
</template>

<script>
import bank from './addon/bank.vue'
import source_env from "./addon/source.vue";
import cur_load from "./addon/cur_load.vue";
import money_load from "./addon/money_load.vue";
import Month_pay from "./addon/month_pay";
import all_orders from "./addon/all_orders";
import stop_list_duration from "./addon/stop_list_duration";
import orders_heatmap from "./addon/orders_heatmap";
import { TweenLite } from 'greensock';
import Peity from 'vue-peity'
export default {
	name: "stat_data",
	components: {
        all_orders,
		Month_pay,
		source_env,
		bank,
		cur_load,
		money_load,
		stop_list_duration,
		orders_heatmap,
		Peity
	},
	data() {
		return {
			date: '',
			time: '',
			order_data : {
				order_count : 0,
				order_sum : 0,
				count_by_day : [],
				order_sum_day : []
			},

			o_count : 0,
			o_sum : 0,

		}
	},
	created() {
		this.date = new moment().format('YYYY-MM-DD');
		this.time = new moment().add(60, "minutes").format("HH:mm:ss");

		this.$store.dispatch('dashboard/SET_DASHBOARD_STATE', {date: this.date});
		this.load_all_stat();
	},

	methods: {

		async load_all_stat() {
			let self = this;
			setTimeout(function() {
				 api.get('/internal/user/dashboard/all').then(({data}) => {
					if (data.status == "operation_success") {
						let resp = data.data;
						if(resp.hasOwnProperty("order_count")) {
							self.order_data.order_count = resp.order_count;
						}

						if(resp.hasOwnProperty("count_by_day")) {
							self.order_data.count_by_day = resp.count_by_day;
						}

						if(resp.hasOwnProperty("order_sum")) {
							self.order_data.order_sum = resp.order_sum;
						}

						if(resp.hasOwnProperty("order_sum_day")) {
							self.order_data.order_sum_day = resp.order_sum_day;
						}

					}
				}).catch(err => {
					this.is_load = true;
					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
			},2000);
		},

		onContext(ctx) {
			this.formatted = ctx.selectedFormatted;
			this.selected = ctx.selectedYMD;
			this.$store.dispatch('dashboard/SET_DASHBOARD_STATE', {date: this.selected});
			EventBus.$emit('change_date', {'date': this.selected});
		}
	},


	computed: {
		animatedOrders: function() {
			return this.o_count.toFixed(0);
		},

		animatedSum : function() {
			return this.o_sum.toFixed(0);
		},


		dash_param() {
			return this.$store.state.dashboard.main;
		},
	},

	watch : {
		'order_data.order_count': function(newValue) {
			TweenLite.to(this.$data, 0.5, { o_count : parseInt(newValue) });
		},
		'order_data.order_sum': function(newValue) {
			TweenLite.to(this.$data, 0.5, { o_sum: parseInt(newValue) });
		}
	},


}
</script>

<style scoped>

</style>
